// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_RRj2B","button":"view-header_button_1RQY1","active":"view-header_active_1d4xF","btnExport":"view-header_btnExport_n1ctV","mr":"view-header_mr_1Db8P"};